import React from 'react';
import chartImg from '../assets/attention_chart.png';

export default function About() {
  return (
    <div className="page about-page">
      <div className="about-hero">
        <h1 className="about-title">THE FOCUS CRISIS</h1>
        <div className="about-subtitle">RECLAIM YOUR ATTENTION. LEVEL UP YOUR LIFE.</div>
      </div>

      <div className="about-chart-section">
        <div className="chart-container">
          <img src={chartImg} alt="100-Year Decline in Human Attention Span" className="chart-img" />
        </div>
      </div>

      <div className="about-text-section">
        <div className="about-text-block">
          <p>
            Focusing these days have been a real hassle for the new generation especially since we have so many
            distractions. The chart presents a century‑long, hypothetical decline in human attention span as a smooth,
            downward‑sloping green line that stands out against a dark, cinematic background. It begins in 1926 at a
            high point—300 seconds of sustained focus—reflecting an era shaped by long‑form reading and fewer
            distractions. As the decades progress, the line descends gradually at first, then more sharply as
            television, the internet, smartphones, and social media reshape how people consume information. By 2026,
            the line reaches 60 seconds, symbolizing a modern environment defined by rapid task‑switching and
            constant digital interruption.
          </p>
          <p>
            This website will remove all of those away so you can really find your true focused self. It has all you
            need a coach, tools, and a spot where you can set your intentions and act on them.
          </p>
        </div>
      </div>

      <div className="about-features">
        <div className="feature-card">
          <div className="feature-icon">⚔</div>
          <div className="feature-title">SET INTENTIONS</div>
          <div className="feature-text">Turn your daily goals into a game. Every completed intention earns HP and XP.</div>
        </div>
        <div className="feature-card">
          <div className="feature-icon">🧠</div>
          <div className="feature-title">AI COACH</div>
          <div className="feature-text">Powered by Groq AI, your coach analyzes your week and gives personalized advice.</div>
        </div>
        <div className="feature-card">
          <div className="feature-icon">🛠</div>
          <div className="feature-title">TOOL ARSENAL</div>
          <div className="feature-text">All your productivity tools in one place. No more tab hunting.</div>
        </div>
      </div>
    </div>
  );
}
